import React from "react";

type IconComponent = React.ComponentType<{ className?: string }>;

export function ToolbarButton({
  icon: Icon,
  label,
  onClick,
  disabled = false
}: {
  icon: IconComponent;
  label: string;
  onClick: () => void;
  disabled?: boolean;
}): JSX.Element {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-border tw-border-[#03234a] tw-bg-[#03234a] tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-white tw-transition hover:tw-border-[#021b39] hover:tw-bg-[#021b39] disabled:tw-cursor-not-allowed disabled:tw-opacity-60"
    >
      <Icon className="tw-h-4 tw-w-4" />
      <span>{label}</span>
    </button>
  );
}
